import React from "react";
import { Button, Snackbar } from "@mui/material";

const Snack = ({ open, handleClose }) => {
  return (
    <div>
      {/* Snackbar */}
      <Snackbar
        open={open}
        autoHideDuration={3000} // Auto-close after 3 seconds
        onClose={handleClose}
        message="Form Submitted Successfully!" // Simple message in Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }} // Position
        ContentProps={{
          sx: {
            backgroundColor: "#4caf50", // Green background
            color: "#fff", // White text
            fontWeight: "bold", // Bold text
            display: "flex", // Flexbox for alignment
            justifyContent: "center", // Center horizontally
            alignItems: "center", // Center vertically
          },
        }}
      />
    </div>
  );
};

export default Snack;
